<template>
    <h1>An error occured</h1>
</template>